import { FaChevronCircleDown, FaChevronCircleUp } from "react-icons/fa";
import { useState, useRef, useEffect } from "react";
import defaultAxios from 'axios';
import { useNavigate } from "react-router-dom";
import { FiLink } from "react-icons/fi";
import { backendUrl } from "../common/constantVarialble";

interface ProgramType {
    program_id: string;
    code: string;
    prg_description: string;
    depth: number;
    last_update_psn: string;
    last_update_dte: string;
    input_psn: string;
    input_dte: string;
}

interface ProgramArr {
    data: ProgramType[] | null;
}

interface SqlResponse {
    sql: string; // Adjust the type accordingly based on your API response
    // Add other properties if needed
}

const getProgramDetail = async (program_ID: string) => {
    try {
        const { data } = await defaultAxios({
            method: 'post',
            //url: 'http://localhost:5000/api/request/',
            url: backendUrl,
            data: {
                program_id: 'PERCENT-ADMIN-PRG-L-LSTSQLBYPROGRAMID',
                params: {
                    'program_id': program_ID,
                },
                page_index: -1,
            },
        });

        return data?.data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

function MainDisplay({ data }: ProgramArr) {

    const navigate = useNavigate();

    const [selectedProgramID, setSelectedProgramId] = useState("");
    const selectedProgramRef = useRef<HTMLDivElement>(null);
    const [sql, setSQL] = useState<SqlResponse | null>(null)

    const PARAMETER = "parameter";
    const HISTORY = "hisotry";
    const DESCRIPTION = "description";
    const TEST = "test";
    const [programDetailMenu, setProgramDetailMenu] = useState(PARAMETER);

    const [programData, setProgramData] = useState<ProgramArr>();
    const [programDescription, setProgramDescription] = useState<ProgramType>();


    useEffect(() => {
        if (data) {
            setProgramData({ data });
            setSelectedProgramId("");
        }
    }, [data]);


    if (!data) {
        return null; // Data is not available
    }



    if (!programData?.data) {
        return null; // Data is not available
    }


    const onProgramIDClick = async (code: string) => {
        navigate(`/admin/sql/program?program_id=${code}`);
        // search detail of program.code
        if (code !== selectedProgramID) {
            setSelectedProgramId(code);
            // Scroll the selected program into view
            if (selectedProgramRef.current) {
                selectedProgramRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
            const programDtl = await getProgramDetail(code);

            if (programDtl) {
                //setSQL([programDtl]);
                setSQL(programDtl[0]);
                setProgramDescription(programDtl[0]);
            }
        } else {
            setSelectedProgramId("");
        }
    };

    const programDetailTabClick = (menu: string) => {
        if (menu === programDetailMenu) {
            return
        } else {
            setProgramDetailMenu(menu);
        }
    }

    const onAddNewProgramClick = () => {
        navigate("/admin/sql/addprogram");
    }

    return (
        <div className="flex flex-1  min-h-screen scroll-auto bg-gray-800 px-4 py-8 flex-col space-y-6">
            {selectedProgramID === "" ?
                <button className="flex p-4 group relative overflow-hidden rounded-lg justify-center bg-indigo-400 text-lg font-bold text-white" onClick={onAddNewProgramClick}>
                    Add new program
                    <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                </button>
                : <></>
            }
            {programData.data?.map((program) => (
                <div
                    className={`flex flex-col ${selectedProgramID !== program.code && selectedProgramID !== ""
                        ? "hidden"
                        : selectedProgramID === program.code && selectedProgramID !== ""
                            ? "h-full"
                            : ""
                        }`}
                    key={program.code}
                    ref={selectedProgramID === program.code ? selectedProgramRef : undefined}
                >
                    <div
                        className={`flex flex-row bg-gray-700 pl-4 items-center space-x-4 overflow-hidden ${selectedProgramID === program.code ? "rounded-t-lg" : "rounded-lg"
                            }`}
                    >
                        <div className="flex flex-col flex-1 my-2">
                            <span className="text-menu">{program.code}</span>
                            {
                                selectedProgramID !== program.code ?
                                    <div className="flex justify-between">
                                        <span className="text-cyan-300">{program.prg_description}</span>
                                        <span className={`text-lime-300 `}>{`${program.last_update_psn}(${program.last_update_dte})`}</span>
                                    </div>
                                    :
                                    <div className="flex justify-end items-end">
                                        <div className={`${selectedProgramID === program.code ? "m-2" : "hidden"}`}>
                                            <button className="group relative h-10 w-40 overflow-hidden rounded-2xl bg-cyan-500 text-lg font-bold text-white">
                                                Push
                                                <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                                            </button>
                                        </div>
                                        <div className={`${selectedProgramID === program.code ? "m-2" : "hidden"}`}>
                                            <button className="group relative h-10 w-40 overflow-hidden rounded-2xl bg-amber-500 text-lg font-bold text-white">
                                                Delete
                                                <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                                            </button>
                                        </div>
                                    </div>

                            }
                        </div>
                        <div
                            className="flex items-center flex-shrink-0 p-0 m-0 h-full cursor-pointer bg-gray-600"
                            onClick={() => onProgramIDClick(program.code)}
                        >
                            {selectedProgramID === program.code ? (
                                <FaChevronCircleUp className="text-white w-10" />
                            ) : (
                                <FaChevronCircleDown className="text-white w-10" />
                            )}
                        </div>
                    </div>
                    {selectedProgramID === program.code ? (
                        <div className="flex flex-row bg-gray-700 h-full border-gray-500 border-t">
                            <div className="flex flex-col w-3/5">
                                <span className="bg-black bg-opacity-70 italic text-white px-4 py-2 border-b border-gray-500 text-sm">.SQL</span>
                                <textarea
                                    className="flex w-full h-3/4 p-4 bg-black bg-opacity-70 text-body border-none resize-none focus:outline-none"
                                    style={{ whiteSpace: 'pre-line' }}
                                    value={sql?.sql || ''}
                                    onChange={(e) => setSQL({ ...sql, sql: e.target.value })}
                                />
                                <textarea
                                    className="flex w-full h-1/4 p-4 bg-black text-body border-none resize-none focus:outline-none"
                                    style={{ whiteSpace: 'pre-line' }}
                                    value={'percent/test/result>_'}
                                    onChange={(e) => setSQL({ ...sql, sql: e.target.value })}
                                />
                            </div>
                            <div className="flex flex-col w-2/5 bg-gray-700">


                                <div className=" bg-gray-700 border-gray-700  px-4 w-full">
                                    <ul className="flex items-center gap-2 text-sm font-medium">
                                        <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(PARAMETER)}>
                                            <span
                                                className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === PARAMETER ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                            >
                                                Parameter
                                            </span>
                                        </li>
                                        <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(DESCRIPTION)}>
                                            <span
                                                className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === DESCRIPTION ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                            >
                                                Description
                                            </span>
                                        </li>
                                        <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(HISTORY)}>
                                            <span
                                                className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === HISTORY ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                            >
                                                COMMITS
                                            </span>
                                        </li>
                                        <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(TEST)}>
                                            <span
                                                className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === TEST ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                            >
                                                Test
                                            </span>
                                        </li>



                                    </ul>
                                </div>

                                <div className=" h-full flex flex-col w-full bg-gray-900 text-body justify-center items-center px-10 py-4">
                                    <form className="w-full">
                                        <div className="flex flex-wrap -mx-3 mb-6">
                                            <div className="w-full px-3">
                                                <label className="block uppercase tracking-wide text-xs text-white  font-bold mb-2">
                                                    PROGRAM ID
                                                </label>
                                                <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="nick" type="text" value={programDescription?.program_id} />
                                                <p className="text-gray-600 text-xs italic">Remove if not needed</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap -mx-3 mb-6">
                                            <div className="w-full px-3">
                                                <label className="lock uppercase tracking-wide text-xs text-white  font-bold pb-2">
                                                    Description
                                                </label>
                                                <textarea className=" no-resize appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-48 resize-none" id="message" value={programDescription?.prg_description}></textarea>
                                                <p className="text-gray-600 text-xs italic">Re-size can be disabled by set by resize-none / resize-y / resize-x / resize</p>
                                            </div>
                                        </div>
                                        {
                                            programDescription &&
                                            <div className="flex flex-wrap -mx-3 mb-6">
                                                <div className="w-full px-3">
                                                    <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                                                        First commit user
                                                    </label>
                                                    <p className="text-body  border-b border-b-gray-100 pb-2">{programDescription.input_psn}</p>
                                                </div>
                                            </div>
                                        }
                                        <div className="flex flex-wrap -mx-3 mb-6">
                                            <div className="w-full px-3">
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                                                    First commit date
                                                </label>
                                                <p className="text-body  border-b border-b-gray-100 pb-2">{program.input_dte}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap -mx-3 mb-6">
                                            <div className="w-full px-3">
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                                                    Last commit user
                                                </label>
                                                <p className="text-body  border-b border-b-gray-100 pb-2">{program.last_update_psn}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap -mx-3 mb-6">
                                            <div className="w-full px-3">
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                                                    Last commit date
                                                </label>
                                                <p className="text-body  border-b border-b-gray-100 pb-2">{program.last_update_dte}</p>
                                            </div>
                                        </div>

                                    </form>


                                </div>

                            </div>
                        </div>
                    ) : null}
                </div>
            ))}
        </div>
    );
}

export { MainDisplay };
